import script from "./slider.vue?vue&type=script&setup=true&lang=js"
export * from "./slider.vue?vue&type=script&setup=true&lang=js"

import "./slider.vue?vue&type=style&index=0&id=1b3089ac&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3089ac"]])

export default __exports__